import React from 'react';

export type VerticalLineProps = {
  height: number;
  color?: string;
  stroke?: 'solid' | 'dashed' | 'dotted';
  thickness?: number;
  className?: string;
};

export const VerticalLine: React.FC<VerticalLineProps> = ({
  height,
  color = 'var(--bs-secondary-color)',
  stroke = 'solid',
  thickness = 1,
  className = '',
}) => {
  return (
    <div
      className={className}
      style={{
        width: '1px',
        height: `${height}px`,
        content: ' ',
        borderLeft: `${thickness}px ${stroke} ${color}`,
      }}
    />
  );
};
